import React, { ChangeEvent } from "react"
import Input, { InputProps } from "../Input"
import { debounce } from "lodash"

type TDebouncedInputProps = {
  delay?: number
} & InputProps

const DebouncedInput: React.FC<TDebouncedInputProps> = ({
  delay = 500,
  onChange,
  ...props
}) => {
  const handleChange = debounce(
    (event: ChangeEvent<HTMLInputElement>) => onChange?.(event),
    delay,
  )

  return <Input onChange={handleChange} {...props} />
}

export default DebouncedInput
